import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { UnauthenticatedException, useApi } from '@/functions/api'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

export function useInitApp () {
  type AppInitResponse = {
    user: AuthenticatedUser,
    branch: AuthenticatedBranch,
    sales_people: SalesPerson[],
    settings: {
      vat_percentage: number,
      sale_printable_seconds: number,
    },
  }

  const route = useRoute()
  const router = useRouter()

  const api = useApi()
  const auth = useAuthStore()
  const app = useAppStore()

  const init = async () => {
    try {
      auth.$reset()
      const response = await api.GET<AppInitResponse>('cashier/init')
      auth.setUser(response.user)
      auth.setBranch(response.branch)
      app.setSalesPeople(response.sales_people)
      app.setVatPercentage(response.settings.vat_percentage)
      app.setSalePrintableSeconds(response.settings.sale_printable_seconds)
    } catch (error) {
      if (error instanceof UnauthenticatedException) {
        return
      }
    }

    if (isOnGuestPage(route.name as string)) {
      await router.replace('/' + (route.query.r ?? ''))
    }
    auth.setAuthenticated(1)
  }

  return {
    init,
  }
}

// route where authenticated user should not be able to access
export function isOnGuestPage (routeName: string) {
  return ['login'].includes(routeName)
}
